var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileCurveMask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 429,
    viewBox: "0 0 375 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 429L-3.05176e-05 429L5.93772e-06 12C5.93772e-06 12 52 188.884 187.5 188.884C323 188.884 375 188.884 375 188.884L375 429Z",
    fill: "#0c71e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCurveMask);
export default __webpack_public_path__ + "static/media/mobile-curve-mask.ea279b9eddda8b22322cd6bb414f232a.svg";
export { ForwardRef as ReactComponent };